export default __webpack_public_path__ + "static/race-day-relay-vertical-67980c42f4fab1bdd3b65c7a0aeedb89.png";